const SuffixContants = {
  DEPARTMENT_TYPE: 'department_type',
};

export default SuffixContants;
